import { render, staticRenderFns } from "./SupplierFinancials.vue?vue&type=template&id=1ce80c3e"
import script from "./SupplierFinancials.vue?vue&type=script&lang=js"
export * from "./SupplierFinancials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports